export default "/images/244f0960cac5589ebcb6d82d8a64fcd9.avif";